import {
  Control, FieldErrors, SetFieldValue, UseFormWatch,
} from 'react-hook-form';
import { NavigateFunction } from 'react-router-dom';
import { VesselInformationFields } from './type.d';

export enum VesselInformationMainEnum {
  vessel = 'vessel',
  testEnd = 'testEnd',
  tubeType = 'tubeType',
  material = 'material',
  support = 'support',
  NWT = 'NWT',
  NWT1 = 'NWT1',
  NWT2 = 'NWT2',
  NWT3 = 'NWT3',
  nwtBellLand = 'NWTBellLand',
  nwtBellLand1 = 'NWTBellLand1',
  nwtBellLand2 = 'NWTBellLand2',
  nwtBellLand3 = 'NWTBellLand3',
  nwtUnderFins = 'NWTUnderFins',
  nwtUnderFins1 = 'NWTUnderFins1',
  nwtUnderFins2 = 'NWTUnderFins2',
  nwtUnderFins3 = 'NWTUnderFins3',
  probeDiameter = 'probeDiameter',
  probeDiameter1 = 'probeDiameter1',
  probeDiameter2 = 'probeDiameter2',
  probeDiameter3 = 'probeDiameter3',
  OD = 'OD',
  OD1 = 'OD1',
  OD2 = 'OD2',
  OD3 = 'OD3',

  tubeCount = 'tubeCount',
  tubeLength = 'tubeLength',

  analyst = 'analyst',
  inspectionDate = 'inspectionDate',
  retestDate = 'retestDate',
}

export interface FirstPropsType {
  control: Control<T>;
  errors: FieldErrors;
  jobOrderId: string;
  watch: UseFormWatch<VesselInformationFields>;
  setValue: SetFieldValue;
}

export interface DataType {
  Value: string;
  Text: string;
  Description?: boolean;
}

export interface VesselMainDataById {
  Id: number;
  VesselId: number;
  VesselName: string;
  JobOrder: string;
  MaterialId: number;
  MaterialType: string;
  SupportId: number;
  Support: string;
  Od: number;
  Od2: string;
  Od3: string;
  Nwt: number;
  Nwt1: number;
  Nwt3: number;
  NwtBellLand: number;
  NwtBellLand1: number;
  NwtBellLand3: number;
  NwtUnderFills: number;
  NwtUnderFills1: number;
  NwtUnderFills3: number;
  ProbeDiameter1: number;
  ProbeDiameter: number;
  ProbeDiameter3: number;
  TubeTypeId: number;
  TubeType: string;
  TubeCount: string,
  TubeLength: number,
  TestEnd: string;
  TestEndId: number;
  Analyst: string;
  AnalystId: number;
  InspectionDate: string;
  RetestDate: string;
  IsMultiOffset: boolean;
}

export interface GetDropDownList {
  Text: string;
  Value: string;
  Description?: boolean | string;
}

export interface CommonFieldsProps {
  tubeTypeData: GetDropDownList[];
  testEndData: GetDropDownList[];
  materialData: GetDropDownList[];
  supportData: GetDropDownList[];
  vesselData: GetDropDownList[];
  errors: FieldErrors;
  vesselMainData: VesselMainDataById;
  isNWTTubeTypeEnabled: GetDropDownList;
  roleId: string | null;
}

export interface VesselMainInitialValues {
  vesselMainData: VesselMainDataById;
  isLoading: boolean;
  tubeTypeData: GetDropDownList[];
  testEndData: GetDropDownList[];
  materialData: GetDropDownList[];
  supportData: GetDropDownList[];
  vesselData: GetDropDownList[];
  isASMESection: boolean;
}

export interface GetVesselMainPayload {
  jobId: string;
  vesselId: string;
  navigate?: NavigateFunction;
}

export interface VesselMainPayloadAPI {
  Id: number;
  VesselId: number;
  JobOrder: string;
  RecordId: string;
  TestEndId: number;
  TubeTypeId: number;
  MaterialId: number;
  SupportId: number;
  Od: number;
  // Od1: number;
  Od2: string;
  Od3: string;
  Nwt: number;
  Nwt1: number;
  Nwt3: number;
  NwtBellLand: number;
  NwtBellLand1: number;
  NwtBellLand3: number;
  NwtUnderFills: number;
  NwtUnderFills1: number;
  NwtUnderFills3: number;
  AnalystId: string;
  InspectionDate: string;
  RetestDate: string;
  ProbeDiameter: number;
  ProbeDiameter1: number;
  ProbeDiameter3: number;
  TubeCount: string;
  TubeLength: number;
  TubeNumbering: boolean;
}

export interface VesselPayloadType {
  id: string;
}
